export default "__VITE_ASSET__Darkun7___"